module.exports = __webpack_public_path__ + "img/map-panel-globe-icon.4f13238e.svg";